var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag:common", arg: "common" }],
      attrs: {
        title: "导入敏感因素",
        visible: _vm.visible,
        "show-close": false,
        width: "400px"
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "exclusiveImport",
          staticClass: "demo-form-inline",
          attrs: { model: _vm.formData, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "敏感因素文件",
                "label-width": "110px",
                prop: "fileId"
              }
            },
            [
              _c(
                "el-upload",
                {
                  ref: "uploadFile",
                  attrs: {
                    limit: 1,
                    action: _vm.action,
                    data: { file: "file", apiKey: _vm.getToken(), type: 9 },
                    "on-success": (response, file, fileList) =>
                      _vm.onFileUploadSuccess(
                        response,
                        file,
                        fileList,
                        "fileId"
                      ),
                    "file-list": _vm.fileListMap.fileIdList,
                    "on-remove": (file, fileList) =>
                      _vm.removeFile(file, fileList, "fileId"),
                    "on-change": (file, fileList) =>
                      _vm.handleChange(file, fileList, "fileId"),
                    accept: ".kmz,.zip"
                  }
                },
                [
                  _c(
                    "ct-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "敏感因素类别",
                prop: "exclusiveTypeId",
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择类别" },
                  model: {
                    value: _vm.formData.exclusiveTypeId,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "exclusiveTypeId", $$v)
                    },
                    expression: "formData.exclusiveTypeId"
                  }
                },
                _vm._l(_vm.exclusveTypeList, function(item) {
                  return _c("el-option", {
                    attrs: { label: item.name, value: item.dataId }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }